<template>
  <v-container>
    <v-card v-if="lookup" class="pa-4" color="background" flat tile>
      <v-form class="ma-6" ref="form" @submit.prevent="getAppraisalFee">
        <v-card class="mx-auto text-center" max-width="500">
          <v-card-title>
            Property Information
          </v-card-title>
          <v-card-text>
            <v-select
              v-model="appraisalPropertyInfo.programType"
              :items="lookup.programType"
              label="Program Type"
              :rules="[requiredNotAllowZero]"
              outlined
              dense
            ></v-select>
            <v-select
              v-model="appraisalPropertyInfo.occupancyType"
              :items="lookup.occupancyType"
              label="Occupancy Type"
              :rules="[requiredNotAllowZero]"
              outlined
              dense
            ></v-select>
            <v-select
              v-model="appraisalPropertyInfo.propertyType"
              :items="lookup.propertyType"
              label="Property Type"
              :rules="[requiredNotAllowZero]"
              outlined
              dense
            ></v-select>
            <v-text-field
              label="Sales/Est. Value"
              v-model="appraisalPropertyInfo.salesValue"
              v-mask="$store.state.mask.currency"
              :rules="[required, currency]"
              prefix="$"
              outlined
              dense
            ></v-text-field>
            <v-select
              v-model="appraisalPropertyInfo.requestType"
              :items="lookup.requestType"
              label="Request Type"
              :rules="[requiredNotAllowZero]"
              outlined
              dense
            ></v-select>
            <v-select
              v-model="appraisalPropertyInfo.state"
              :items="
                $store.state.selectList.state.filter((x) =>
                  [null, `CA`].includes(x.key)
                )
              "
              item-text="displayName"
              item-value="key"
              label="State"
              :rules="[required]"
              outlined
              dense
            ></v-select>
            <v-select
              v-if="countyList && appraisalPropertyInfo.state"
              v-model="appraisalPropertyInfo.countyCode"
              :items="countyList.filter((x) => x.state === 'CA')"
              item-text="countyName"
              item-value="countyCode"
              label="County"
              :rules="[requiredNotAllowZero]"
              outlined
              dense
            ></v-select>
            <v-btn
              type="submit"
              :loading="submitting"
              color="primary"
              width="300"
            >
              Find Fee
            </v-btn>
          </v-card-text>
        </v-card>
      </v-form>
      <v-card class="mx-auto text-center" color="white" max-width="500">
        <v-card-text>
          <p class="text-h6">Fee Amount</p>
          <p class="text-h5 font-weight-black primary--text">
            <span v-if="fee">{{ fee | currency }}</span>
            <span v-else>N/A</span>
          </p>
        </v-card-text>
      </v-card>
      <br />
    </v-card>
  </v-container>
</template>

<script>
import { rules, convert } from "@/mixins";

export default {
  name: "AppraisalFeeFinder",
  async mounted() {
    this.lookup = await this.$store
      .dispatch("tblAppraisalFee/getAll")
      .then((resp) => resp.data)
      .catch(() => null);

    this.countyList = await this.$store
      .dispatch("county/getAllVM")
      .then((resp) => resp.data)
      .catch(() => null);
  },
  data() {
    return {
      submitting: false,
      lookup: null,
      countyList: null,
      appraisalPropertyInfo: {
        mortgageType: null,
        occupancyType: null,
        propertyType: null,
        salesValue: null,
        requestType: null,
      },
      fee: null,
    };
  },
  methods: {
    async getAppraisalFee() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        this.appraisalPropertyInfo.salesValue = this.toParseFloat(
          this.appraisalPropertyInfo.salesValue
        );

        await this.$store
          .dispatch("price/getAppraisalFeeAmount", this.appraisalPropertyInfo)
          .then((resp) => {
            this.fee = resp.data;
          })
          .catch(() => {
            this.fee = null;
            this.$store.commit(
              "statusDialog/showErrorDialog",
              "Unable to find Appraisal Fee."
            );
          });

        this.submitting = false;
      }
    },
  },
  mixins: [rules, convert],
};
</script>
